/**
 * useLanguage Hook
 * 管理語言狀態和翻譯
 */

import { useState, useCallback, useMemo } from 'react';
import { type Language, type Translations, getTranslations } from '../i18n';

const STORAGE_KEY = 'mjj-trading-tool-lang';

function getInitialLanguage(): Language {
  if (typeof window === 'undefined') return 'zh-TW';
  
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && ['zh-TW', 'zh-CN', 'en'].includes(stored)) {
    return stored as Language;
  }
  
  // 根據瀏覽器語言自動選擇
  const browserLang = navigator.language;
  if (browserLang.startsWith('zh-CN') || browserLang === 'zh-Hans') {
    return 'zh-CN';
  }
  if (browserLang.startsWith('zh')) {
    return 'zh-TW';
  }
  if (browserLang.startsWith('en')) {
    return 'en';
  }
  
  return 'zh-TW';
}

export function useLanguage() {
  const [language, setLanguageState] = useState<Language>(getInitialLanguage);

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  }, []);

  const t = useMemo<Translations>(() => getTranslations(language), [language]);

  return {
    language,
    setLanguage,
    t,
  };
}

export default useLanguage;
